module.exports = __webpack_public_path__ + "static/media/globe.5d4534fb.svg";